export default function ({commit, dispatch}, {field, value}) {
    let data = {};
    switch (field) {
        case 'Contragent':
            commit('legals');
            data = {
                ContragentId: value.value,
                ContragentName: value.label,
                ContragentType: 1,
            };
            switch (value.type) {
                case 'partner':
                    data.ContragentType = 2;
                    setTimeout(() => {
                        dispatch('get_legal', {partner: value.value});
                    });
                    break;
                case 'partnerLegal':
                    commit('legals', [{
                        value: value.value,
                        label: value.label,
                    }]);
                    data = {
                        ContragentId: value.PartnerID,
                        ContragentName: value.PartnerName,
                        ContragentType: 2,
                        PartnerLegalId: value.value,
                    };
                    break;
            }
            break;
        default:
            data[field] = value;
    }
    commit('set', data);
}
